import React from 'react';
import '../Style/ProcessFlowItem.css';
import {FaCheck} from 'react-icons/fa';

const ProcessFlowItemView = (props) => {
    const {activeClassName, title, onClick = null, flowItemType} = props;

    return (
        <>
            <div onClick={onClick} className={`${flowItemType}-container`}>
                <p className={`${flowItemType}-p flowItem-${activeClassName}`}>{title}</p>
                <div className={`${flowItemType}-circle ${flowItemType}-${activeClassName}`} >
                    {activeClassName === 'pass' ? <FaCheck color='white' size={10}/> : <div className='inner-circle-flow'/>}
                </div>
                <div className={`${flowItemType}-verticalLine ${flowItemType}-${activeClassName}`}/>
            </div>
        </>
    );
};

export default ProcessFlowItemView;
